<mat-list role="list">
    <mat-list-item role="listitem" *ngFor="let point of editdata" str>
      {{point.lat.toPrecision(5) }},
      {{point.lng.toPrecision(5) }}</mat-list-item
    >
  </mat-list>